const initialState = {
  data:[],
  chatdata:[],
  };

const OrgDonarChatReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_DATA_SUCCESS':
      return { ...state, data: action.payload };

      
    case 'FETCH_DATA_SUCCESS_MASchat':
      
      return{ ...state, chatdata: action.payload }
    default:
      return state;
  }
};

export default OrgDonarChatReducers;

